import { Link } from "react-router-dom";
import { kindLabel, microsToCredits, shortHex, type Tx } from "../api";

interface Props {
  tx: Tx;
}

const STATUS_CLASS: Record<Tx["status"], string> = {
  TENTATIVE: "bg-mesh-warn/20 text-mesh-warn",
  FINAL: "bg-mesh-ok/20 text-mesh-ok",
  INVALID: "bg-mesh-err/20 text-mesh-err",
};

export default function TxRow({ tx }: Props) {
  return (
    <div className="flex flex-wrap min-w-0 items-center justify-between gap-3 py-2 border-b border-mesh-panel/60 text-sm">
      <Link
        to={`/tx/${tx.tx_id}`}
        title={tx.tx_id}
        aria-label={`Transaction ${tx.tx_id}`}
        className="hex text-mesh-accent hover:underline w-40 max-w-full shrink-0"
      >
        {shortHex(tx.tx_id, 8, 6)}
      </Link>
      <span className="px-2 py-0.5 rounded bg-mesh-panel/60 text-xs uppercase">
        {kindLabel(tx.kind)}
      </span>
      <div className="flex w-full min-w-0 items-center gap-3 lg:w-auto">
        <span className="hex text-mesh-mute min-w-0 flex-1 lg:w-32 lg:flex-none truncate">
          {tx.sender ? (
            <Link
              to={`/account/${tx.sender}`}
              title={tx.sender}
              aria-label={`Account ${tx.sender}`}
              className="hover:text-mesh-accent"
            >
              {shortHex(tx.sender)}
            </Link>
          ) : (
            "—"
          )}
        </span>
        <span className="text-mesh-mute">→</span>
        <span className="hex text-mesh-mute min-w-0 flex-1 lg:w-32 lg:flex-none truncate">
          {tx.receiver ? (
            <Link
              to={`/account/${tx.receiver}`}
              title={tx.receiver}
              aria-label={`Account ${tx.receiver}`}
              className="hover:text-mesh-accent"
            >
              {shortHex(tx.receiver)}
            </Link>
          ) : (
            "—"
          )}
        </span>
      </div>
      <span className="text-right w-full min-w-0 break-all lg:w-28 shrink-0">
        {tx.kind === 0 ? `${microsToCredits(tx.amount)} cr` : ""}
      </span>
      <span
        className={`px-2 py-0.5 rounded text-xs ${STATUS_CLASS[tx.status]}`}
      >
        {tx.status}
      </span>
      <span className="text-xs text-mesh-mute w-16 text-right">
        {tx.witness_round != null ? `r${tx.witness_round}` : "—"}
      </span>
    </div>
  );
}
